// MatchDay.js
import React from 'react';
import MatchItem from './MatchItem';
import styles from './MatchList.module.css';

const formatDate = (dateString) => {
  try {
    const [year, month, day] = dateString.split('-').map(Number);
    const date = new Date(Date.UTC(year, month - 1, day));
    return date.toLocaleDateString('pl-PL', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' });
  } catch {
    return 'Nieznana data';
  }
};

const MatchDay = ({ date, matches, favoriteTeams, onToggleFavorite }) => (
  <div className={styles.dayBlock}>
    <div className={styles.dateHeader}>{formatDate(date)}</div>
    <div className={styles.matchList}>
      {matches.map(match => (
        <MatchItem
          key={match._id}
          match={match}
          isFavorite={favoriteTeams.includes(match.home) || favoriteTeams.includes(match.title)}
          onToggleFavorite={onToggleFavorite}
        />
      ))}
    </div>
  </div>
);

export default MatchDay;